export default __webpack_public_path__ + "static/media/RUBRIQUEKOJY-CHAT.9ee8335d.png";